/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { TamiGAWDtchi, TamiGAWDtchiInterface } from "../TamiGAWDtchi";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "prayer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "enum TamiGAWDtchi.PrayerType",
        name: "prayerType",
        type: "uint8",
      },
    ],
    name: "Prayed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
      {
        indexed: true,
        internalType: "address",
        name: "resurrector",
        type: "address",
      },
    ],
    name: "Resurrected",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress_",
        type: "address",
      },
    ],
    name: "__TrustedForwarderRecipientUpgradeable_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "boonHealthOverride",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "cower",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getAlive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getAllBlockStats",
    outputs: [
      {
        internalType: "uint256[5]",
        name: "",
        type: "uint256[5]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getAllStats",
    outputs: [
      {
        internalType: "uint256[6]",
        name: "",
        type: "uint256[6]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlockNumber",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBlocksUntilDeath",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCowerBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getCowerCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getCowerCooldownBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getCurrentGawdBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getDeployedBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getHealth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMarvelBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getMarvelCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMarvelCooldownBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getPrecision",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getResurrectCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getResurrectCooldownBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSacrificeBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getSacrificeCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSacrificeCooldownBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getSecondsPerBlock",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getTrueHealth",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWorshipBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "getWorshipCooldown",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getWorshipCooldownBlocks",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarderAddress",
        type: "address",
      },
      {
        internalType: "contract IRebaser",
        name: "rebaserAddress",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "marvel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "prayers",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rebaser",
    outputs: [
      {
        internalType: "contract IRebaser",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "resurrect",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "sacrifice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "secondsPerBlock",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocksUntilDeath",
        type: "uint32",
      },
    ],
    name: "setBlocksUntilDeath",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setCowerBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setCowerCooldownBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trustedForwarder_",
        type: "address",
      },
    ],
    name: "setForwarder",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setMarvelBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setMarvelCooldownBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IRebaser",
        name: "_rebaser",
        type: "address",
      },
    ],
    name: "setRebaser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setResurrectCooldownBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setSacrificeBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setSacrificeCooldownBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "blocks",
        type: "uint16",
      },
    ],
    name: "setSecondsPerBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setWorshipBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint32",
        name: "blocks",
        type: "uint32",
      },
    ],
    name: "setWorshipCooldownBlocks",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "versionRecipient",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "gawd",
        type: "uint16",
      },
    ],
    name: "worship",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type TamiGAWDtchiConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TamiGAWDtchiConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TamiGAWDtchi__factory extends ContractFactory {
  constructor(...args: TamiGAWDtchiConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "TamiGAWDtchi";
  }

  override deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<TamiGAWDtchi> {
    return super.deploy(overrides || {}) as Promise<TamiGAWDtchi>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): TamiGAWDtchi {
    return super.attach(address) as TamiGAWDtchi;
  }
  override connect(signer: Signer): TamiGAWDtchi__factory {
    return super.connect(signer) as TamiGAWDtchi__factory;
  }
  static readonly contractName: "TamiGAWDtchi";

  public readonly contractName: "TamiGAWDtchi";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TamiGAWDtchiInterface {
    return new utils.Interface(_abi) as TamiGAWDtchiInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TamiGAWDtchi {
    return new Contract(address, _abi, signerOrProvider) as TamiGAWDtchi;
  }
}
